import React from 'react'
import R from 'ramda'
import PropTypes from 'prop-types'
import { Form, Button } from 'semantic-ui-react'

import BaseSelectField from '_forms/baseSelect'

const propStr = prop => R.compose(
  R.defaultTo(''),
  R.prop(prop)
)

const propBool = prop => R.compose(
  R.defaultTo(false),
  R.prop(prop)
)

const getUsername = propStr('username')
const getEmail = propStr('email')
const getLastName = propStr('last_name')
const getFirstName = propStr('first_name')
const getDisplayname = propStr('displayname')
const getUrl = propStr('url')
const getDescription = propStr('description')
const getStatus = propStr('status')
const getTcPp = propBool('accepts_tc_pp')

export const STATUS_VALUES = [
  {text: 'Active', value: 'active'},
  {text: 'Pending', value: 'pending'},
  {text: 'Not Active', value: 'not_active'}
]

const AcceptsTcPp = ({
  checked
}) => checked
  ? (<Form.Checkbox label='User accepted TC/PP' checked={true} />)
  : (<Form.Checkbox error label='User has not accepted TC/PP' checked={false} />)

AcceptsTcPp.propTypes = {
  checked: PropTypes.bool.isRequired
}

const UserProfileForm = ({
  profile,
  dirty,
  onSubmit,
  onChange,
  onCancel,
  readOnly
}) => {

  return (
    <Form size='tiny' onSubmit={onSubmit}>
      <Form.Group>
        <Form.Input readOnly={ readOnly } width={5} label='Username' name='username' placeholder='LEAVE EMPTY UNLESS SET' value={getUsername(profile)} onChange={onChange} />
        <Form.Input readOnly={ readOnly } width={6} label='Email' name='email' placeholder='Email (required)' value={getEmail(profile)} onChange={onChange} type='email'/>
        <BaseSelectField
          readOnly={ readOnly }
          name='status'
          width={5}
          onChange={onChange}
          value={getStatus(profile)}
          labelTxt='Status'
          popupTxt='Active == user is all verfied, Pending = user needs to verify email, Not Active = user is no longer valid, can no longer sign in or auth.'
          options={STATUS_VALUES}
        />
      </Form.Group>
      <Form.Group>
        <Form.Input readOnly={ readOnly } width={5} label='First Name' name='first_name' placeholder='First name (required)' value={getFirstName(profile)} onChange={onChange} />
        <Form.Input readOnly={ readOnly } width={5} label='Last Name' name='last_name' placeholder='Last name (required)' value={getLastName(profile)} onChange={onChange} />
        <Form.Input readOnly={ readOnly } width={6} label='Display Name' name='displayname' placeholder='Display name (required)' value={getDisplayname(profile)} onChange={onChange} />
      </Form.Group>
      <Form.Group>
        <Form.Input readOnly={ readOnly } width={5} label='URL' name='url' placeholder='Url' value={getUrl(profile)} onChange={onChange} />
        <Form.TextArea
          width={11}
          label='Description'
          name='description'
          placeholder='Description'
          rows={2}
          readOnly={ readOnly }
          value={getDescription(profile)}
          onChange={onChange}
        />
      </Form.Group>
      <Form.Group>
        <AcceptsTcPp checked={getTcPp(profile)}/>
      </Form.Group>
      {
        readOnly ? null : (
          <Button.Group>
            <Button disabled={ !dirty} onClick={onCancel}>Cancel</Button>
            <Button.Or />
            <Button positive={dirty} disabled={!dirty} type="submit">Save</Button>
          </Button.Group>
        )
      }
    </Form>
  );
}

UserProfileForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  profile: PropTypes.object.isRequired,
  dirty: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired
}

export default UserProfileForm;



// WEBPACK FOOTER //
// ./webAdmin/forms/userProfileForm.js